/* FABEL — product-form.js : validated AJAX add to cart + sticky mobile bar. */
(function () {
  'use strict';
  const FABEL = window.FABEL;

  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.button = this.querySelector('[data-add-button]');
      this.errorEl = this.querySelector('[data-form-error]');
      this.variantInput = this.querySelector('[data-variant-id-input]');
      this.selects = document.querySelector(`variant-selects[data-section="${this.dataset.section}"]`);
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    /* Returns the label of the first unchosen required option, or null. */
    missingOption() {
      if (!this.selects) return null;
      const count = parseInt(this.selects.dataset.optionCount || '0', 10);
      for (let i = 1; i <= count; i += 1) {
        const hasInputs = this.selects.querySelector(`input[data-option-position="${i}"]`);
        if (hasInputs && !this.selects.querySelector(`input[data-option-position="${i}"]:checked`)) {
          const group = this.selects.querySelector(`[data-option-group="${i}"]`);
          return (group && group.getAttribute('data-option-name')) || '';
        }
      }
      return null;
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.querySelector('[data-form-error-text]').textContent = message;
      this.errorEl.setAttribute('data-visible', 'true');
      FABEL.announce(message);
    }

    clearError() {
      if (this.errorEl) this.errorEl.removeAttribute('data-visible');
    }

    onSubmit(event) {
      event.preventDefault();
      this.clearError();

      const missing = this.missingOption();
      if (missing !== null) {
        const isSize = (FABEL.strings.sizeOptionNames || []).some(
          (name) => name.toLowerCase() === String(missing).toLowerCase()
        );
        const message = isSize
          ? FABEL.strings.selectSizeError
          : FABEL.strings.selectOptionError.replace('[option]', String(missing).toLowerCase());
        this.showError(message);
        const group = this.selects.querySelector(`[data-option-group]`);
        if (group) group.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      if (!this.variantInput || !this.variantInput.value) {
        this.showError(FABEL.strings.variantUnavailable);
        return;
      }

      this.setLoading(true);
      FABEL.cart.add(new FormData(this.form)).then((result) => {
        this.setLoading(false);
        if (result.error) {
          this.showError(result.error);
          return;
        }
        FABEL.announce(FABEL.strings.itemAdded);
        if (FABEL.settings.cartType === 'drawer') {
          FABEL.cart.open(this.button);
        } else {
          window.location.href = FABEL.routes.cart_url;
        }
      });
    }

    setLoading(state) {
      if (!this.button) return;
      this.button.setAttribute('data-loading', state ? 'true' : 'false');
      this.button.disabled = state;
    }
  }
  if (!customElements.get('product-form')) customElements.define('product-form', ProductForm);

  /* ------------------------------------------------------- sticky mobile -- */
  class StickyAtc extends HTMLElement {
    connectedCallback() {
      this.anchor = document.querySelector(this.dataset.anchor || '[data-atc-anchor]');
      this.button = this.querySelector('[data-sticky-add]');

      if (this.button) {
        this.button.addEventListener('click', () => {
          const form = document.querySelector(`product-form[data-section="${this.dataset.section}"] form`);
          if (!form) return;
          const target = document.querySelector('[data-atc-anchor]');
          const missing = document
            .querySelector(`product-form[data-section="${this.dataset.section}"]`)
            ?.missingOption();
          if (missing !== null && missing !== undefined && target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
        });
      }

      if (!this.anchor || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.setAttribute('data-visible', show ? 'true' : 'false');
          });
        },
        { threshold: 0 }
      );
      this.observer.observe(this.anchor);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }
  if (!customElements.get('sticky-atc')) customElements.define('sticky-atc', StickyAtc);
})();
